<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DYNAMIC HIERARCHY {{ isDraft ? 'DRAFT' : '' }}
        </h2>
        <v-breadcrumbs
          class="px-0 text-capitalize"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-flex>
      <v-spacer />
      <v-card class="dynamic">
        <v-card-title>
          <v-flex xs9 class="pl-1 text-capitalize">
            {{
              type === 'create'
                ? isDraft
                  ? 'Create Dynamic Hierarchy Draft'
                  : 'Create Dynamic Hierarchy'
                : isDraft
                ? 'Edit Dynamic Hierarchy Draft'
                : 'Edit Dynamic Hierarchy'
            }}
          </v-flex>
          <v-spacer />
          <level-group
            v-if="node.level"
            :div="node"
            @postLevel="assignLevel"
            :isDraft="isDraft"
            class="pl-2 mt-2"
          />
          <v-col cols="auto" class="text-right" v-if="isDetail || isEdit">
            <v-icon title="refresh" @click="getDetail()">
              refresh
            </v-icon>
          </v-col>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs7 class="pa-0 form-hierarchy">
                <!-- <v-flex xs10 class="pr-0">
                  <v-row>
                    <v-col cols="9" class="py-0">
                      <ValidationProvider
                        name="Division"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label class="darkblue--text">Division</label>
                        <v-autocomplete
                          id="division"
                          single-line
                          outlined
                          dense
                          placeholder="Division"
                          v-model="items.div_id"
                          :items="itemsDiv"
                          required
                          :error-messages="errors"
                          :disabled="isDetail"
                          item-value="id"
                          item-text="name"
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="auto" class="pt-7">
                      <v-btn
                        color="green"
                        dark
                        @click="addRowGroup(items, 'group')"
                        ><v-icon>add</v-icon> Add Group</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-flex> -->
                <ul>
                  <li>
                    <dynamic-form
                      :node="node"
                      :division="itemsDiv"
                      noRemove
                      :budget_owners="budget_owners"
                      :divisi="divisi"
                    />
                  </li>
                </ul>
                <!-- <v-flex xs12 class="py-0" v-if="items.group.length > 0">
                  <v-treeview
                    open-all
                    dense
                    :items="items.group"
                    class="pa-0 dynamic-hierarchy"
                    style="margin-left: -40px"
                  >
                    <template v-slot:prepend="{ item }" style="width: 100%">
                      <v-flex
                        xs10
                        class="primary br-10 mb-4"
                        v-if="item.type === 'group' && !item.isDelete"
                      >
                        <h4 class="white--text">Stucture Group</h4>
                      </v-flex>
                      <v-flex xs12 class="pa-0">
                        <v-row
                          class="px-3"
                          v-if="item.type === 'bo' && !item.isDelete"
                        >
                          <v-col cols="2" class="py-0 pt-2"
                            >BO {{ item.id + 1 }}</v-col
                          >
                          <v-col cols="4" class="py-0">
                            <ValidationProvider
                              name="BO Name"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                id="bo"
                                single-line
                                outlined
                                dense
                                placeholder="BO Name"
                                v-model="item.name"
                                required
                                :error-messages="errors"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-btn
                            class="mt-1 mr-2"
                            color="red"
                            dark
                            title="remove group"
                            ><v-icon large class="icon-medium"
                              >delete_outline</v-icon
                            >
                          </v-btn>
                        </v-row>
                        <v-row class="px-3" v-else>
                          <template v-if="!item.isDelete">
                            <v-col cols="2" class="py-0 pt-2"
                              >{{
                                item.type === 'group' ? 'Group ' : 'Sub Group '
                              }}
                              {{ item.id + 1 }}</v-col
                            >
                            <v-col cols="4" class="py-0">
                              <ValidationProvider
                                name="Group Name"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  id="group"
                                  single-line
                                  outlined
                                  dense
                                  placeholder="Group Name"
                                  v-model="item.name"
                                  required
                                  :error-messages="errors"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-btn
                              class="mt-1 mr-2"
                              color="bluePurple"
                              dark
                              @click="addRowGroup(item, 'subgroup')"
                              ><v-icon large class="icon-medium">add</v-icon>Sub
                              Group</v-btn
                            >
                            <v-btn
                              class="mt-1 mr-2"
                              color="red"
                              dark
                              title="remove group"
                              @click="confirmRemove(item, 'group')"
                              ><v-icon large class="icon-medium pt-3 pr-1"
                                >maximize</v-icon
                              >
                              {{
                                item.type === 'group' ? ' Group' : ' Sub Group'
                              }}</v-btn
                            >
                            <v-btn
                              class="mt-1 mr-2"
                              color="primary"
                              dark
                              @click="addRowGroup(item, 'bo')"
                              ><v-icon large class="icon-medium">add</v-icon
                              >BO</v-btn
                            >
                          </template>
                        </v-row>
                      </v-flex>
                    </template>
                  </v-treeview>
                </v-flex> -->
              </v-flex>
              <v-flex xs5 class="preview-hierarchy">
                <org-chart :datasource="node" pan></org-chart>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right pt-6 px-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right>
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  @click="goBack()"
                >
                  {{ id === 'id' ? 'Cancel' : 'Back' }}
                </v-btn>
              </v-flex>
              <v-flex xs2 right v-if="!isDetail" class="ml-4">
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="saveConfirm('draft')"
                >
                  Save As Draft
                </v-btn>
              </v-flex>
              <v-flex xs2 right v-if="!isDetail" class="ml-4">
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="primary"
                  block
                  @click="saveConfirm('apply')"
                >
                  Apply
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../components/progress_dialog';
import dynamicForm from '../../components/dynamicHierarchy/form.vue';
import 'sweetalert2/src/sweetalert2.scss';
import OrgChart from 'vue-organization-chart';
import 'vue-organization-chart/dist/orgchart.css';
import Level from '../../components/dynamicHierarchy/level.vue';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'dynamic-form': dynamicForm,
    'level-group': Level,
    OrgChart
  },
  props: ['type', 'id'],
  data() {
    return {
      node: {
        division_id: null,
        name: '',
        type: 'parent',
        children: [],
        level: {}
      },
      itemstree: [],
      itemsDiv: [],
      listMenu: [],
      items: {
        div_id: '',
        group: []
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      loading: false,
      progressDialogLoading: false,
      search: '',
      isDetail: false,
      isEdit: false,
      breadcrumbs: [
        {
          text: 'Organization Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Dynamic Hierarchy List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text:
            this.type === 'create'
              ? 'Create Dynamic Hierarchy'
              : 'Edit Dynamic Hierarchy',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      budget_owners: [],
      divisi: {},
      isDraft: false
    };
  },
  async mounted() {
    this.checkDraft();
    if (this.type !== 'create') {
      this.isEdit = true;
      this.isDetail = false;
      this.getDetail();
    }
    await this.getDivision();
    await this.getBO();
  },
  watch: {
    items: {
      handler: function(val) {
        return val;
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    assignLevel(val) {
      this.node.level = val;
    },
    checkDraft() {
      let path = this.$route.path;
      let type = path.split('/');
      if (type[2] === 'draft') {
        this.isDraft = true;
      } else {
        this.isDraft = false;
      }
    },
    getDetail() {
      this.progressDialogLoading = true;
      let endpoint = '';
      if (this.isDraft) {
        endpoint = 'dynamic/detailDraftHierarchy';
      } else {
        endpoint = 'dynamic/detailHierarchy';
      }
      this.$store
        .dispatch(endpoint, this.id)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            localStorage.setItem('hierarchyBefore', JSON.stringify(data.data));
            if (!this.isDraft) {
              this.node.division_id = Number(data.data.id);
              this.node.name = data.data.name;
              this.node.children = data.data.children || [];
            } else {
              this.node.division_id = Number(data.data.division_id);
              this.node.name = data.data.hierarchy.name;
              this.node.level = data.data.hierarchy.level;
              this.node.children = data.data.hierarchy.children || [];
            }
            this.divisi = {
              id: this.node.division_id,
              name: this.node.name
            };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    getBO() {
      let params = {
        ids: this.selectedBO
      };
      return this.$store
        .dispatch('dynamic/getBO', params)
        .then(data => {
          if (data.code === 200) {
            this.budget_owners = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDivision() {
      return this.$store
        .dispatch('division/getAll', {
          paginate: false
        })
        .then(data => {
          if (data.code === 200) {
            this.itemsDiv = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    saveConfirm(type) {
      let text = type === 'draft' ? 'save as draft' : 'apply';
      Swal.fire({
        title: 'Are you sure?',
        text: `Are you sure want to ${text} this data?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          let body = {
            division_id: this.node.division_id,
            hierarchy: {
              id: this.node.division_id,
              name: this.node.name,
              children: this.node.children,
              level:
                Object.keys(this.node.level).length === 0 &&
                this.node.level.constructor === Object
                  ? { level: [] }
                  : this.node.level
            },
            before: JSON.parse(localStorage.getItem('hierarchyBefore'))
          };
          let endpoint = '';
          let routerName = '';
          let params = null;
          if (!this.isEdit) {
            params = body;
            if (type === 'apply') {
              endpoint = 'dynamic/createHierarchy';
              routerName = 'dynamic-hierarchy';
            } else {
              endpoint = 'dynamic/createDraft';
              routerName = 'draft-hierarchy';
            }
          } else {
            params = {
              id: this.id,
              params: body
            };
            if (type === 'apply') {
              endpoint = 'dynamic/createHierarchy';
              routerName = 'dynamic-hierarchy';
              params = body;
            } else if (!this.isDraft && type === 'draft') {
              endpoint = 'dynamic/createDraft';
              routerName = 'draft-hierarchy';
              params = body;
            } else if (this.isDraft && type === 'draft') {
              endpoint = 'dynamic/updateDraft';
              routerName = 'draft-hierarchy';
            }
          }
          this.$store
            .dispatch(endpoint, params)
            .then(data => {
              this.progressDialogLoading = false;
              if (data.code === 200) {
                if (type === 'apply') {
                  this.applyHierarchy(type, params);
                } else {
                  Swal.fire('Success!', data.message.text_en, 'success');
                  this.$router.push({
                    name: routerName
                  });
                }
              } else {
                console.log(data);
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log(err);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      });
    },
    applyHierarchy(type, body) {
      this.progressDialogLoading = true;
      let endpoint = '';
      let payload = null;
      if (!this.isDraft) {
        endpoint = 'dynamic/applyHierarchy';
        payload = body;
      } else {
        endpoint = 'dynamic/updateApply';
        payload = {
          id: this.id,
          params: body
        };
      }
      this.$store
        .dispatch(endpoint, payload)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.$router.push({
              name: 'dynamic-hierarchy'
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({
        name: this.isDraft ? 'draft-hierarchy' : 'dynamic-hierarchy'
      });
    }
  }
};
</script>
<style>
.icon-medium {
  font-size: 25px !important;
}
.preview-hierarchy .orgchart-container {
  position: sticky;
  top: 85px;
}
.form-hierarchy {
  /* overflow: auto; */
}
</style>
